import { h } from 'preact'
import ButtonControlSelector from '../button-control-selector'

interface Props {
  isEventModuleEnabled: boolean
}

export default (props: Props) => {
  const getSelectorItems = () => {
    const contentTypes = [
      {
        isPrincipal: true,
        title: 'New article',
        href: '/content/new/article'
      },
      {
        title: 'New conversation',
        href: '/topic/new?content_type=discussion'
      },
      {
        title: 'New question',
        href: '/topic/new?content_type=question'
      }
    ]

    if (props.isEventModuleEnabled) {
      contentTypes.push({
        title: 'New event',
        href: '/content/new/event'
      })
    }

    return contentTypes
  }

  return <div>
    <ButtonControlSelector items={getSelectorItems()} />
  </div>
}
